export default "__VITE_ASSET__YtWIoAny__"